module.exports = __webpack_public_path__ + "static/media/2-3-2_OPP_Matt_02.cb12015e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Printing-Techniques/2-3-2_OPP_Matt_02.jpg
// module id = 566
// module chunks = 0